export var StockAdjustmentKeys = {
    create: 'stockAdjustmentCreate',
    update: 'stockAdjustmentUpdate',
    get: 'stockAdjustmentGetById',
    paging: 'stockAdjustmentPaging',
    adjustmentTypes: 'adjustmentTypes',
    locations: 'locationsByWarehouse',
    parts: 'partList',
    serialNumber: 'serialNumber_',
    availableQty: 'availableQty_',
    defaultTracking: "checkDefaultTrackingType",
    productPrice: "getProductPrice",
    warehouse: "warehouseList"
};
export var StockAdjustmentMandatoryFields = {
    'ProductId': 'Product',
    'AdjustmentTypeId': 'AdjustmentType',
    'UOM': 'UOM',
    // 'SerialNo':'SerialNumber',
    'LocationId': 'Location',
    'BasePrice': 'BasePrice',
    'PurchasePrice': 'PurchasePrice',
    'AdjustedQuantity': 'AdjustedQuantity'
};
